import type { ThemeOptionVariant } from '../../theme/augmentation'
import type { SnackbarOptions, SnackbarMessage, SnackbarProviderProps, Toast } from './types'

const getWidth = (variant: ThemeOptionVariant) => {
  switch (variant) {
    case 'desktop':
    case 'tablet':
      return 460
    case 'md':
    case 'lg':
      return '45vw'
    case 'xl':
      return '50vw'
    case 'mobile':
    default:
      return 320
  }
}

const getPosition = (variant: ThemeOptionVariant) => {
  switch (variant) {
    case 'desktop':
    case 'tablet':
    case 'md':
    case 'lg':
    case 'xl':
      return 'bottomRight'
    case 'mobile':
    default:
      return 'topCenter'
  }
}

export const normalizeToastOptions = (
  message: SnackbarMessage,
  providerProps: SnackbarProviderProps,
  variant: ThemeOptionVariant,
  toastProps?: SnackbarOptions
) =>
  ({
    message,
    visible: true,
    action: toastProps?.action,
    duration: toastProps?.persist ? 0 : toastProps?.autoHideDuration || providerProps.autoHideDuration || 6000,
    key: toastProps?.key ?? (toastProps?.preventDuplicate ? JSON.stringify(message) : Date.now()),
    position: toastProps?.position || providerProps.position || getPosition(variant),
    preventDuplicate: toastProps?.preventDuplicate || false,
    severity: toastProps?.severity || 'success',
    title: toastProps?.title,
    transitionDuration: toastProps?.transitionDuration || 300,
    variant: toastProps?.variant || 'filled',
    width: providerProps.width || getWidth(variant),
    onClose: toastProps?.onClose,
  }) satisfies Toast
